// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"171":"dd8dd97e","594":"94bb6df2","686":"d1660339","715":"92434cff"}[chunkId] + ".js";
};